import React, { Component, Fragment } from "react";
import AUX from "../../hoc/Aux_";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "../Shared/auth-header";
import { toast } from "react-toastify";
import $ from "jquery";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import TableCustomTotal from '../Shared/TableCustomTotal';
const { SearchBar } = Search;
const columns = [
    {
        text: "Team Name",
        dataField: "name",
        sort: true
    },
    {
        text: "Member Count",
        dataField: "count",
        sort: true
    }
];

class TeamsLookup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            totalCount: "",
            teamsMethods: this.props.teamsMethods
        };
        this.rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.state.teamsMethods().setTeam(row);
            }
        };
    }
    componentWillMount() {
        $(".loading").show();
        const url = `/api/Team/GetTeams`;
        const formData = {
            PageNo: 1,
            PageSize: 10,
            Name: $("#keyword").val(),
            MemberName: "",
            PositionName: "",
            OperatorType: "AND",
            SortOrder: "NameAsc"
        };
        axios.post(url, formData).then(({ data }) => {
            if (data.status && data.status.toLowerCase() == "success") {
                this.setState({ rows: data.data, totalCount: data.totalCount });
                $(".loading").hide();
            } else {
                $(".loading").hide();
                toast.error(data.message);
            }
        });
    }
    render() {
        return (
            <AUX>
                <div className="container-fluid">
                    <div className="page-title-box">
                        <div className="row align-items-center">
                            <div className="col-sm-6">
                                <h4 className="page-title">Teams</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <ToolkitProvider keyField="id" data={this.state.rows} columns={columns} search>
                                {props => (
                                    <Fragment>
                                        <div className="d-flex justify-content-center mb-2">
                                            <div className="col-6 text-center app-search">
                                                <SearchBar className="form-control mb-1 w-100" {...props.searchProps} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <BootstrapTable
                                                    striped
                                                    hover
                                                    pagination={paginationFactory({ paginationTotalRenderer: TableCustomTotal })}
                                                    {...props.baseProps}
                                                    rowEvents={this.rowEvents}
                                                />
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </ToolkitProvider>
                        </div>
                    </div>
                </div>
            </AUX>
        );
    }
}

export default TeamsLookup;
